<template>
  <div class="content">
    <el-dialog
      title="关联下游付款"
      class="flow-dialog"
      :visible.sync="dialogVisible"
      width="80%"
      @close="close"
    >
      <div class="content-main-box content-main-box2">
        <!-- 搜索区域保持不变 -->
        <div class="search-area">
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="search-area-div w80">关键字搜索</div>
              <el-input
                v-model="page.searchKey"
                placeholder="请输入企业、组织、应付金额搜索"
                size="mini"
                class="ipt-sty"
              >
              </el-input>
            </el-col>
            <!-- <el-col :span="6"
              ><div class="search-area-div">核算月份：</div>
              <el-date-picker
                size="mini"
                v-model="page.accountMonth"
                class="ipt-sty"
                value-format="yyyy-MM"
                type="month"
                placeholder="请选择"
              >
              </el-date-picker>
            </el-col> -->
            <el-col :span="8" class="search-btn-box">
              <el-button size="mini" type="info" @click="search"
                >搜索</el-button
              >
              <el-button size="mini" type="danger" @click="empty"
                >清空</el-button
              >
            </el-col>
          </el-row>
        </div>

        <!-- 表格区域 -->
        <el-table
          stripe
          border
          ref="tableRef"
          :max-height="320"
          :data="settleList"
          :row-key="(row) => row.guid"
          @selection-change="handleSelectionChange"
          :header-cell-class-name="cellClass"
          @current-change="handleCurrentChange"
        >
          <el-table-column type="selection" :reserve-selection="true">
          </el-table-column>
          <el-table-column
            prop="flowNo"
            label="流程编号"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">{{
              scope.row?.approveVO?.flowNo || "-"
            }}</template>
          </el-table-column>
          <el-table-column
            prop="flowName"
            label="流程名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.approveVO && scope.row.approveVO.flowName
                ? scope.row.approveVO.flowName
                : "-"
            }}</template>
          </el-table-column>
          <!-- 发起人 -->
          <el-table-column
            prop="applyStaffName"
            width="80"
            label="发起人"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.applyStaffName || "-" }}
            </template>
          </el-table-column>
          <!-- 企业名称 -->
          <el-table-column
            prop="operationReportTenantName"
            width="150"
            label="企业名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.operationReportTenantName || "-" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="serviceTenantName"
            width="150"
            label="总服务商"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.serviceTenantName || "-" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="tenantName"
            width="150"
            label="接包服务商"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.tenantName || "-" }}
            </template>
          </el-table-column>
          <!-- 组织名称 -->
          <el-table-column
            prop="organisationName"
            width="150"
            label="组织名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.organisationName || "-" }}
            </template>
          </el-table-column>
          <!-- 核算月 -->
          <el-table-column
            prop="accountMonth"
            label="核算月"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.newAccountMonth || "-" }}
            </template>
          </el-table-column>
          <!-- 任务包名称 -->
          <!-- <el-table-column
            prop="taskTitleName"
            label="任务包名称"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.operationReportTaskTitle
                ? JSON.parse(scope.row.operationReportTaskTitle).join("、")
                : "-"
            }}</template>
          </el-table-column> -->
          <!-- 应付金额 -->
          <el-table-column
            width="120"
            prop="payable"
            label="应付金额(元)"
            header-align="center"
            align="right"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.payable | numFmt | numDigit
            }}</template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer">
        <el-button plain size="mini" @click="close">取消</el-button>
        <el-button size="mini" type="info" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SettlePayDialog",
  data() {
    return {
      dialogVisible: false,
      page: {
        searchKey: "",
      },
      settleList: [],
      selectedRows: [], // 存储勾选的数据
      tenantGuidList: [], // 父组件传进来的 [总服务商公司]
      threeTenantGuidList: [], // 父组件传进来的 [接包服务商]
      operationReportTenantGuid: "", // 父组件传进来的 [企业名称]
      accountMonth: "", // 父组件传进来的 [核算月]
    };
  },
  methods: {
    open(data) {
      this.dialogVisible = true;
      this.selectedRows = [...(data.selectedRows || [])];
      this.tenantGuidList = [...(data.tenantGuidList || [])];
      this.threeTenantGuidList = [...(data.threeTenantGuidList || [])];
      this.operationReportTenantGuid = data.operationReportTenantGuid || "";
      this.accountMonth = data.accountMonth || "";
      this.getSettleList();
    },
    close() {
      this.dialogVisible = false;
      this.clearSelection();
      this.$emit("close");
    },
    // 清空选择
    clearSelection() {
      this.selectedRows = [];
      if (this.$refs.tableRef) {
        this.$refs.tableRef.clearSelection();
      }
    },

    // 处理选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleCurrentChange(val) {
      if (!val) return;
      // 检查是否有选中的行
      const isSelected = this.selectedRows.some((row) => row.guid === val.guid);
      // 勾选或取消勾选
      if (isSelected) {
        this.$refs.tableRef.toggleRowSelection(val, false);
      } else {
        this.$refs.tableRef.toggleRowSelection(val, true);
      }
    },

    // 确定按钮
    submit() {
      if (!this.selectedRows.length) {
        this.$message.error("请选择数据");
        return;
      }
      // 将勾选的数据传给父组件
      console.log(this.selectedRows);
      this.$emit("submit", this.selectedRows);
      this.close();
    },
    async getSettleList() {
      let userInfo = JSON.parse(localStorage.userInfo);
      const params = {
        operationReportTenantGuid: this.operationReportTenantGuid,
        threeTenantGuidList: this.threeTenantGuidList,
        tenantGuidList: this.tenantGuidList,
        staffGuid: userInfo.staffGuid,
        accountMonth: this.accountMonth?.replace("-", "") || "",
        searchKey: this.page.searchKey,
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/downstream/payment/operation-select-list`,
        params
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.settleList = (data.data || []).map((item) => {
        let newAccountMonth = JSON.parse(item.accountMonth) || [];
        newAccountMonth = newAccountMonth?.join(",") || "";
        return {
          ...item,
          newAccountMonth,
        };
      });
      if (!this.selectedRows.length) {
        return;
      }
      const selectedRowsCopy = [...this.selectedRows];
      this.settleList?.forEach((item) => {
        if (selectedRowsCopy.includes(item.guid)) {
          this.$refs.tableRef.toggleRowSelection(item, true);
        }
      });
    },
    search() {
      this.getSettleList();
    },

    empty() {
      this.page = {
        searchKey: "",
      };
      this.$emit("getFlowList");
    },

    cellClass(row) {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.flex-between {
  display: flex;
  justify-content: space-between;
}

.total-tip {
  text-align: right;
  margin: 0 0 16px 0;
}

.total-tip span {
  color: #ff5f1f;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
  display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
  content: "";
  text-align: center;
  line-height: 37px;
}

.content {
  padding: 0px;
  margin: 0px;

  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;

    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }

    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .mt-4 {
    margin-top: 4px;
  }

  .pd-16 {
    padding-bottom: 16px;
  }

  .form-box {
    margin-top: 4px;
    text-align: left;

    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
      font-weight: 500;
    }

    /deep/ .el-row {
      margin: 0px !important;
    }

    .el-form-item {
      margin-bottom: 8px;
    }

    .over-label /deep/ .el-form-item__label {
      line-height: 21px;
    }

    .el-input {
      width: 220px;
    }

    .age-are-box {
      display: flex;
      align-items: center;

      .el-select {
        width: 142px;
      }

      span {
        margin: 0px 8px;
      }
    }

    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;

      .el-button--primary {
        color: #ffffff;
      }
    }
  }

  /deep/ .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #d9d9d9;
  }

  /deep/ .el-dialog__body {
    padding: 0px 20px;
  }

  /deep/ .el-dialog__footer {
    padding: 10px 20px;
    border-top: 1px solid #d9d9d9;
  }

  .content-main-box2 {
    height: 55vh;
    overflow-x: hidden;

    .search-area {
      padding: 16px 0px;
    }

    .el-table {
      border-left: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
      border-bottom: 1px solid #d8d8d8;
    }
  }

  .flow {
    background: #fff;
    padding-left: 20px;
  }

  .iframe-sty {
    width: 100%;
    border: none;
    height: 600px;
  }

  .detail-box {
    height: auto;
  }

  .cannel-btn {
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    color: #212121;
  }

  .initiate-box {
    display: flex;
    align-items: center;
    padding: 26px 0px;

    .el-select {
      margin-left: 10px;
    }
  }
  .table-expand {
    padding-left: 10px;
  }
}
.search-area .el-col-8 {
  justify-content: flex-start;
}
</style>
